<div class="sg-flex-column sg-justify-around sg-items-start">
  @if (title) {
  <div class="sg-justify-start sg-items-center">
    <mat-icon color="primary">stars</mat-icon>
    <div class="sg-flex-auto"></div>
    <h2 class="sg-no-margin sg-margin-left-16">{{ title }}</h2>
  </div>
  }
  <div class="sg-self-center sg-pos-rel sg-pie-container">
    <ngx-charts-pie-chart
      #pieChart
      [arcOuterStroke]="arcOuterStrokeColor"
      [view]="pieData.view"
      [doughnut]="true"
      [scheme]="pieData.scheme"
      [activeEntries]="activeEntries"
      [results]="pieData.results"></ngx-charts-pie-chart>
    <div
      [style.height]="(pieChart.innerRadius * sqrt2) + 'px'"
      [style.width]="(pieChart.innerRadius * sqrt2) + 'px'"
      class="sg-trapped-pie-text sg-text-center sg-color-header sg-flex-column sg-justify-around sg-items-center">
      @if (doughnutViewTpl) {
      <div><ng-container *ngTemplateOutlet="doughnutViewTpl; context: { $implicit: doughnut }"></ng-container></div>
      } @else {
      <span class="sg-trapped-pie-text-title mat-h1" [ngStyle]="{ 'fontSize.px': pieChart.innerRadius * sqrt2 * .5 }" data-test="numOfSecurities">
        {{ getDoughnutProperty('securities') }}
      </span>
      @if (getDoughnutProperty('text')) {
      <div class="sg-trapped-pie-text-desc">{{getDoughnutProperty('text')}}</div>
      } @if (getDoughnutProperty('buttonText')) {
      <button style="min-height: 36px" mat-flat-button color="primary" (click)="buttonClick.emit()" data-test="securitiesPieButton">
        {{getDoughnutProperty('buttonText')}}
      </button>
      } }
    </div>
  </div>
  @if (legend) {
  <div class="sg-self-center">
    <ngx-charts-legend
      class="chart-legend"
      [title]="legendTitle"
      [data]="legendChartNames"
      [colors]="legendColors"
      (labelActivate)="legendLabelActivate($event)"
      (labelDeactivate)="legendLabelDeactivate()"></ngx-charts-legend>
  </div>
  }
</div>
